<a class="header" [ngClass]="'header--' + (state | async)" routerLink="/">
  @if (themeService.theme$ | async | logoImage: (state | async); as logo) {
    <img [src]="logo" alt="Image" class="image-header" />
  }
</a>

<div class="content">
  <osp-panel-menu [model]="$sidenavItems()"></osp-panel-menu>
</div>

<div class="footer">
  @if (state | async; as sidebarState) {
    @if (sidebarState !== 'collapsed') {
      <osp-button
        [category]="'secondary'"
        [icon]="pinToggleIcon$ | async"
        [ospTooltip]="pinToggleTooltip$ | async"
        (onClick)="toggleFixingState()"
      />
    }
  }
</div>
